function getVariantImage(images, image, variantImageId) {
  if (!variantImageId) return image;
  return images?.find((img) => img?.id === variantImageId) ?? image;
}

export default getVariantImage;
